import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[700px] flex items-center justify-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20ink%20wash%20painting%20style%20background%20with%20soft%20warm%20cream%20and%20deep%20charcoal%20tones%2C%20subtle%20brush%20strokes%2C%20traditional%20Chinese%20aesthetic%20blended%20with%20modern%20minimalist%20design%2C%20floating%20ink%20particles%2C%20ethereal%20atmosphere%2C%20clean%20composition%2C%20no%20text%2C%20artistic%20texture&width=1920&height=1080&seq=hero-bg-01&orientation=landscape"
          alt="土豪漫画网 - 免费漫画在线观看"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/60 via-foreground-950/40 to-background-50/90"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-4xl mx-auto">
          {/* Tag */}
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-background-50/30 bg-background-50/10 backdrop-blur-sm mb-8">
            <span className="w-2 h-2 rounded-full bg-accent-400"></span>
            <span className="text-sm text-background-50/90 font-medium">每日更新 1,280+ 话</span>
          </div>

          {/* Title */}
          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight mb-6">
            高清韩漫
            <br />
            人气聚合
          </h1>

          {/* Description */}
          <p className="text-base md:text-lg text-background-50/80 max-w-2xl mx-auto mb-10 leading-relaxed">
            土豪漫画网提供<strong>免费漫画下拉式</strong>浏览和<strong>高清韩漫人气榜</strong>，
            在线观看韩国漫画，追踪热门趋势，享受视觉精彩盛宴
          </p>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/all"
              className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-base font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              免费漫画专区
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to="/category/all"
              className="px-8 py-3.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/30 text-background-50 text-base font-medium hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              查看人气榜
              <i className="ri-fire-line ml-2"></i>
            </Link>
          </div>

          {/* Stats */}
          <div className="flex items-center justify-center gap-10 md:gap-16 mt-16">
            <div className="text-center">
              <div className="font-heading text-2xl md:text-3xl font-bold text-background-50">36,000+</div>
              <div className="text-sm text-background-50/60 mt-1">漫画资源</div>
            </div>
            <div className="w-px h-10 bg-background-50/20"></div>
            <div className="text-center">
              <div className="font-heading text-2xl md:text-3xl font-bold text-background-50">850万+</div>
              <div className="text-sm text-background-50/60 mt-1">注册用户</div>
            </div>
            <div className="w-px h-10 bg-background-50/20"></div>
            <div className="text-center">
              <div className="font-heading text-2xl md:text-3xl font-bold text-background-50">120亿+</div>
              <div className="text-sm text-background-50/60 mt-1">累计阅读</div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 z-10">
        <span className="text-xs text-background-50/50">向下滚动</span>
        <div className="w-5 h-8 rounded-full border-2 border-background-50/30 flex items-start justify-center p-1">
          <div className="w-1.5 h-1.5 rounded-full bg-background-50/60 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}